import thLocale from 'element-ui/lib/locale/lang/th'
const th_TH = {
    header: {
        user: 'อธิบายแจกแจง',
        password: 'รหัสผ่าน',
        forget: 'ลืมรหัสผ่าน?',
        login: 'ล็อกอิน',
        register: 'ลงทะเบียน',
        verification: 'กรุณาใส่ตัวเลขที่เห็น',
        mainAccount: 'บัญชีหลัก',
        mineAccount: 'บัญชีของฉัน',
        inEmail: 'จดหมายสถานี',
        loginOut: 'ออกจากระบบ',
        Betting: 'บันทึกการเดิมพัน',
        withdraw: 'การถอนเงินออนไลน์',
        deposit: 'เงินฝากออนไลน์',
        transaction: 'บันทึกการซื้อขาย',
        checkUsername: 'กรุณาใส่หมายเลขบัญชี',
        checkPassword: 'กรุณาใส่รหัสผ่าน',
        checkVrifyCode: 'กรุณาใส่รหัสผ่าน',
        refresh:'บัญชีปริมาณรีเฟรชเรียบร้อยแล้ว',
        seeMore:'ดูเพิ่มเติม',
        hotDiscount:'ข้อเสนอร้อนแรง',
        customer:'บริการออนไลน์',
        downloadUrl:'ดาวน์โหลดแอพ',
        Eventhall:'สถานที่จัดงาน',
        Mobilebetting:'เดิมพันมือถือ',
        Mobilebettin2:'สแกนเพื่อดาวน์โหลดแอพมือถือ',
        Mobilebettin3:'ต่อต้านการหักหลังต่อต้านการกระโดด',
        Home:'บ้าน',
    },
    register: {
        open: 'เปิดผู้ใช้',
        user: 'บัญชีสมาชิก:',
        userPlace: '6-12 ตัวอักษรและตัวเลขและเริ่มต้นด้วยตัวอักษร',
        password: 'รหัสผ่านสมาชิก:',
        passwordPlace: '6-12 หลักต้องมีตัวอักษรและตัวเลข',
        phone: 'หมายเลขโทรศัพท์มือถือ:',
        phonePlace: 'โปรดป้อนหมายเลขโทรศัพท์ของคุณ',
        phoneTips: 'หมายเลขโทรศัพท์มือถือเป็นวิธีสำคัญในการยืนยันข้อมูลโปรดกรอกอย่างถูกต้อง ',
        agent: 'รหัสตัวแทน:',
        agentPlace: 'ไม่จำเป็นต้องกรอกข้อมูล',
        verification: 'รหัสยืนยัน:',
        verificationPlace: 'กรุณาใส่รหัสยืนยัน',
        rule: 'ฉันอายุมากกว่า 18 ปีและได้อ่านและยอมรับข้อกำหนดและเงื่อนไขและนโยบายความเป็นส่วนตัว',
        btn: 'ส่งการลงทะเบียน',
        pleaseRead: 'โปรดอ่านนโยบายความเป็นส่วนตัว',
        download: 'ดาวน์โหลดแอปมือถือ',
        style: 'วิธีการฝาก',
        paytd: 'ให้ช่องทางการชำระเงินที่รวดเร็ว',
        copyright: 'ลิขสิทธิ์เกม',
        realName: 'ชื่อจริง',
        realNamePlace: 'โปรดป้อนชื่อจริง (ไม่จำเป็น)',
        realNamePlace_: 'โปรดป้อนชื่อจริง',
        QQ: 'QQ',
        qqPlace: 'โปรดป้อนหมายเลข QQ (ไม่จำเป็น)',
        qqPlace_: 'โปรดป้อนหมายเลข QQ',
        wx: 'WeChat',
        wxPlace: 'โปรดป้อน WeChat (ไม่จำเป็น)',
        wxPlace_: 'โปรดป้อน WeChat',
        email: 'อีเมล',
        emailPlace: 'โปรดป้อนที่อยู่อีเมล (ไม่จำเป็น)',
        emailPlace_: 'โปรดป้อนที่อยู่อีเมลของคุณ',
        drawPassword: 'ถอนรหัสผ่าน',
        drawPasswordPlace: 'โปรดป้อนรหัสผ่านการถอน (ไม่จำเป็น)',
        drawPasswordPlace_: 'โปรดป้อนรหัสผ่านการถอนเงิน',
    },
    agency:{
        title: 'Agent Cooperation',
         affiliateAgree: 'ข้อตกลงสมาคม',
         AgencyLogin: 'เข้าสู่ระบบตัวแทน',
         AgencyRegister: 'การลงทะเบียนตัวแทน'
    },
    download:{
        title: 'ศูนย์ดาวน์โหลด',
         appDownload: 'ดาวน์โหลด APP',
         subTitle: 'Android / Apple ดาวน์โหลดโทรศัพท์มือถือ',
         input: 'อินพุตเบราว์เซอร์มือถือ'
    },
    nav:{
        sbSport: 'ซาบาห์สปอร์ต',
         eSport: 'E-sports Bull',
         ugSport: 'UG Sports',
         cmdSport: 'CMD Sports',
         wftSport: 'WFT Sports',
         imSport: 'IM Sports',
         lottery: 'หวย',
         poker: 'โป๊กเกอร์',
         live: 'คนจริง',
         slot: 'อิเล็กทรอนิกส์',
         fish: 'ประมง',
         discounts: 'โปรโมชั่น',
         agency: 'ความร่วมมือตัวแทน',
         remove: 'ย้าย',
    },
    discounts:{
        details: 'ดูรายละเอียด',
        noDiscounts: 'ไม่มีส่วนลดที่เกี่ยวข้อง!',
         discountsReceived: 'รับโบนัส',
         checkPlatform: 'โปรดเลือกแพลตฟอร์ม',
         checkMoney: 'โปรดป้อนจำนวน',
         checkMoneyPlace: 'โปรดป้อนจำนวนเงินที่ฝากเข้าสู่แพลตฟอร์มเกม',
         cancel: 'ยกเลิก',
         confrim: 'ยืนยัน',
         checkBisnum: 'โปรดป้อนหมายเลขสลิปพนัน',
         checkBisnum2: 'โปรดป้อนหมายเลขสลิปพนันเงินฝาก',
         needLoin: 'คุณสามารถรับโบนัสได้หลังจากเข้าสู่ระบบ',
         needLoin2: 'คุณสามารถรับโบนัสได้หลังจากเข้าสู่ระบบ',
         querylevel: 'ระดับการสืบค้น',
         queryresult: 'ผลการค้นหา',
         account: 'บัญชีสมาชิก',
         currentlevel: 'ระดับปัจจุบัน',
         Totalcumulativebets: 'จำนวนเงินเดิมพันรวมทั้งหมด',
         Accumulatedpromotionbonus: 'โบนัสโปรโมชั่นสะสม',
         Accumulatedsalary: 'เงินเดือนสะสม',
         AccumulatedMonthlysalary: 'สะสมโจวเฟิงหลู',
         Totalbetamountrequiredforpromotion: 'จำนวนเงินเดิมพันทั้งหมดที่ต้องการสำหรับการส่งเสริมการขาย'
    },
    forget:{
        RetrieveSMS: 'การดึง SMS',
        MailboxRetrieve: 'การดึงอีเมล',
        CustomerRetrieve: 'การเรียกคืนการบริการลูกค้า',
        sendMsg: 'ส่งรหัสยืนยัน',
        checking: 'ยืนยัน',
        finish: 'เสร็จสิ้น',
        userPlace: 'โปรดป้อนบัญชีเกมของคุณ',
        phonePlace: 'โปรดป้อนหมายเลขโทรศัพท์ที่ถูกผูก',
        emailPlace: 'โปรดป้อนหมายเลขอีเมลที่ถูกผูก',
        sendPhoneMsg: 'ส่งรหัสยืนยันโทรศัพท์',
        sendEmailCode: 'โปรดป้อนหมายเลขกล่องจดหมายที่ถูกผูก',
        sendEmail: 'ส่งรหัสยืนยันกล่องจดหมาย',
        bindPhone: 'โปรดป้อนหมายเลขโทรศัพท์ที่จะผูก',
        bindEmail: 'โปรดป้อนหมายเลขกล่องจดหมายที่ถูกผูก',
        VerifyPlace: 'โปรดป้อนรหัสยืนยัน',
        tips: 'เราได้ส่งรหัสยืนยันไปยังโทรศัพท์มือถือของคุณโปรดตรวจสอบ',
        tips2: 'เราได้ส่งรหัสยืนยันไปยังอีเมลของคุณแล้วกรุณาตรวจสอบ',
        newPasswordPlace: 'โปรดป้อนรหัสผ่านใหม่',
        reNewPasswordPlace: 'โปรดป้อนรหัสผ่านใหม่อีกครั้ง',
        check: 'ยืนยัน',
        resetSuccess: 'การรีเซ็ตรหัสผ่านสำเร็จแล้ว!',
        celebrate:'ขอแสดงความยินดี!',
        determine:'กำหนด',
        CustomerService: 'ติดต่อฝ่ายบริการลูกค้า',
        sendAgain: 'ส่งรหัสยืนยันอีกครั้ง',
        // second: '秒）后重新发送'
    },
    mine: {
        welcome: 'ยินดีต้อนรับคุณ',
        balance: 'ยอดคงเหลือ (THB)',
         minecenter: 'ศูนย์ส่วนบุคคล',
         amountManage: 'การจัดการกองทุน',
         Betting: 'บันทึกการเดิมพัน',
         welfare: 'การเก็บรวบรวมสวัสดิการ',
         transaction: 'รายละเอียดการทำธุรกรรม',
         myDiscount: 'ส่วนลดของฉัน',
         safe: 'ความปลอดภัยของบัญชี',
         inEmail: 'จดหมายสถานี',
         loginOut: 'ออกจากระบบ',
         friend:'เพื่อน',
        center: {
            account: 'บัญชี',
            username: 'ชื่อผู้ใช้',
            balance: 'ยอดเงินในบัญชี',
            money: 'THB',
            name: 'ชื่อ',
            authentication: 'ไปที่การรับรองความถูกต้อง',
            phone: 'มือถือ',
            email: 'กล่องจดหมาย',
            draw: 'Go to fill in',
             Wechat: 'WeChat',
             tips: 'เคล็ดลับที่อบอุ่น',
             congratulations:'ขอแสดงความยินดี',
             success: 'ความสำเร็จ',
             qqConfirm: 'การรับรองหมายเลข QQ',
             qqrule: 'โปรดป้อนหมายเลข QQ ที่ถูกต้อง',
             qqPlace: 'โปรดป้อนหมายเลข QQ ของคุณ',
             wechatrule: 'WeChat authentication',
             wechatrule: 'โปรดป้อนบัญชี WeChat ของคุณ',
             wechatPlace: 'โปรดป้อน WeChat ของคุณ',
             cancel: 'ยกเลิก',
             confrim: 'รับรอง',
        },
        capital: {
            account: 'รายละเอียดบัญชี',
            deposit: 'เงินฝาก',
            withdrawal: 'ถอน',
            bankList: 'การจัดการบัตรเครดิตธนาคาร',
            withdrawalList: 'ใบสมัครถอนเงิน',
            lockAmount: 'รายละเอียดการล็อค',
            accountin: {
                balance: 'เงินในบัญชี',
                refresh: 'รีเฟรช',
                accountBalance: 'ยอดเงินในบัญชี',
                 deposit: 'เงินฝาก',
                 withdrawal: 'ถอน',
                 takeBack: 'หนึ่งคีย์เพื่อรับกลับ',
                 AvailBalance: 'เงินที่ถอนได้',
                 mainBalance: 'บัญชีหลัก',
                 money: 'THB',
                 RMB: 'THB',
                 describe: 'ไม่มีข้อมูลบัญชีเกม! ',
                 describe2: 'ยังไม่มีเกม!',
                 refreshSuccess: 'ยอดเงินในบัญชีรีเฟรชสำเร็จ',
                 takeBacking: 'เดินทางกลับ',
                 takeBackError: 'การดึงคีย์หนึ่งล้มเหลว',
            },
            depositin: {
                deposit: 'เงินฝาก',
                check: 'เลือกวิธีชำระเงินสำหรับการเติมเงินในบัญชี',
                amountTips: 'จำนวนเงินฝาก (THB)',
                pleaseCheck: 'กรุณาเลือกจำนวนเงินฝาก',
                pleaseInput: 'โปรดป้อนจำนวนเงินฝาก',
                next: 'ถัดไป',
                tips1: 'เคล็ดลับที่อบอุ่น',
                tips2: 'หากการเติมเงินล้มเหลวโปรดลองเปลี่ยนช่องทางการชำระเงินหรือวิธีการชำระเงินอื่น',
                tips3: 'หากคุณพบปัญหาใด ๆ โปรดติดต่อเรา',
                customer: 'การบริการลูกค้าออนไลน์',
                CCB: 'ธนาคารเพื่อการก่อสร้าง',
                ABC: 'ธนาคารเกษตร',
                ICBC: 'ไอซีบีซี',
                BOC: 'ธนาคารแห่งประเทศจีน',
                CEB: 'China Everbright Bank',
                PSBC: 'ไปรษณีย์ธนาคารออมสิน',
                CITIC: 'CITIC Bank',
                BCCB: 'ธนาคารแห่งกรุงปักกิ่ง',
                BOS: 'ธนาคารแห่งเซี่ยงไฮ้',
                CMBC: 'Minsheng Bank',
                chooseTd: 'โปรดเลือกช่องทางการชำระเงิน',
                chooseType: 'โปรดเลือกวิธีการชำระเงิน',
                choseBank: 'โปรดเลือกธนาคารการชำระเงินบุคคลที่สาม',
                limit: 'วงเงินฝาก:',
                money: 'THB',
                steady: 'Stable',
                td: 'ช่องทาง',
                limit2: 'ขีด จำกัด เดียว:',
                UnionPayGateway: 'UnionPay Gateway',
                BankRemittance: 'การโอนเงินผ่านธนาคาร',
            },
            withdrawalin: {
                title: 'จำนวนเงินที่ถอนได้',
                amountPlace: 'ป้อนจำนวนเงินที่ถอนได้',
                refresh: 'รีเฟรชยอดคงเหลือที่มี',
                AvailBalance: 'ยอดเงินคงเหลือ:',
                money: 'THB',
                tips: '(จำนวนการถอนเงินสดอยู่ใน',
                tips3: 'สามารถถอนได้ข้างต้นเท่านั้นโปรดอย่าป้อนทศนิยม)',
                choseBankCard: 'โปรดเลือกบัตรธนาคารถอนตัว',
                loading: 'กำลังโหลดอย่างสิ้นหวัง',
                addBankCard: 'เพิ่มบัตรเครดิตธนาคาร',
                tips2: 'คำเตือน: การถอนจำเป็นต้องตั้งรหัสผ่านการถอนและการยืนยันหมายเลขโทรศัพท์มือถือ',
                next: 'ถัดไป',
                diatitle: 'โปรดป้อนรหัสผ่านการถอนเงิน',
                diaPlace: 'โปรดป้อนรหัสผ่านการถอนเงิน',
                confrim: 'ตกลง',
                confrim1Title: 'ไม่ได้ตั้งรหัสผ่านการถอนคุณต้องการตั้งค่าหรือไม่',
                confrim2Title: 'การถอนเงินต้องทำให้การตรวจสอบโทรศัพท์มือถือเสร็จสมบูรณ์คุณต้องการตรวจสอบสิทธิ์หรือไม่',
                confrimTips: 'Warm Tips',
                confirmText: 'ตกลง',
                cancelText: 'ยกเลิก',
                choseBank: 'โปรดเลือกธนาคาร',
                choseAmount: 'ถอนเงินสดใน',
                choseAmount2: 'สามารถถอนได้ด้านบนเท่านั้น',
                noBalance: 'ยอดเงินคงเหลือไม่เพียงพอ',
                noPoint: 'อย่าป้อนทศนิยม',
                nopassword: 'โปรดป้อนรหัสผ่านการถอนเงิน',
                withdrawalSuccess: 'ถอนใบสมัครสำเร็จแล้วรอการตรวจสอบ',
                refreshSuccess: 'รีเฟรชสำเร็จ',
            },
            bankListin: {
                title1: 'ดูบัตรธนาคาร',
                title2: 'เพิ่มบัตรเครดิตธนาคาร',
                loading: 'กำลังโหลดอย่างสิ้นหวัง',
                tips1: 'คำเตือน: โปรดติดต่อฝ่ายบริการลูกค้าเพื่อลบบัตรธนาคาร',
                addBankCard: 'เพิ่มบัตรเครดิตธนาคาร',
                bankUser: 'ผู้ถือบัตร',
                littleTips: 'Warm Tips',
                nameOnce: 'ชื่อผู้ถือบัตรสามารถตั้งค่าได้เพียงครั้งเดียวและต้องสอดคล้องกับการตรวจสอบชื่อจริงสำหรับการแก้ไขที่ตามมากรุณาติดต่อฝ่ายบริการลูกค้า',
                namePlace: 'กรุณาใส่ชื่อผู้ถือบัตร',
                bankNum: 'หมายเลขบัตรเครดิตธนาคาร',
                bankTips: 'โปรดป้อนหมายเลขบัตรเครดิตธนาคารที่ถูกต้องมิฉะนั้นอาจแสดงความผิดปกติ',
                bankPlace: 'โปรดป้อนหมายเลขบัตรเครดิตธนาคาร',
                bankName: 'ชื่อธนาคาร',
                bankNamePlace: 'โปรดป้อนชื่อธนาคาร',
                subbranch: 'สาขาการเปิดบัญชี',
                subbranchPlace: 'โปรดป้อนสาขาที่เปิดบัญชี',
                password: 'ถอนรหัสผ่าน',
                passwordPlace: 'โปรดป้อนรหัสผ่านการถอนเงิน',
                add: 'เพิ่ม',
                footer: 'เพื่อความปลอดภัยของคุณคุณสามารถผูกบัตรธนาคารของผู้ถือบัตรด้วยการตรวจสอบชื่อจริงส่วนบุคคลหากคุณต้องการความช่วยเหลือโปรดติดต่อฝ่ายบริการลูกค้าออนไลน์',
                ConfirmTitle: 'ต้องใช้รหัสผ่านในการถอนเพื่อผูกบัตรธนาคารคุณต้องการตั้งค่าหรือไม่',
                ConfirmTips: 'เคล็ดลับอบอุ่น',
                confirmText: 'ตกลง',
                cancelText: 'ยกเลิก',
                cantBank: 'ไม่สามารถผูกบัตรธนาคารได้ในตอนนี้',
                addSuccess: 'เพิ่มความสำเร็จ',
            },
            withdrawalListlis: {
                loading: 'กำลังโหลดอย่างสิ้นหวัง',
                search: 'ค้นหา',
                time: 'เวลาสมัคร',
                amount: 'จำนวนเงินสมัคร',
                status: 'สถานะแอปพลิเคชัน',
                 bankName: 'ถอนเงินธนาคาร',
                 bankNumber: 'หมายเลขบัตรถอนเงิน',
                 remark: 'หมายเหตุ',
                 statusAll: 'ทั้งหมด',
                 applying: 'การใช้',
                 payment: 'ถอนเงิน',
                 success: 'ความสำเร็จ',
                 reject: 'ปฏิเสธ',
            },
            lockAmountin: {
                rechargeLock: 'ล็อคการเติมเงิน',
                 allStates: 'สถานะทั้งหมด',
                 lockin: 'ล็อค',
                 Unlocked: 'ปลดล็อก',
                 Cancelled: 'ยกเลิก',
                 order: 'หมายเลขซีเรียล',
                 principal: 'เติมเงินต้น (THB)',
                 lockInAmount: 'จำนวนล็อค (THB)',
                 targetFlow: 'Target flow (THB)',
                 flowComple: 'การไหลเสร็จสมบูรณ์ (THB)',
                 lockStatus: 'สถานะการล็อค',
                 handle: 'การดำเนินงาน',
                 Deblocking: 'ปลดล็อก',
                 DiscountLock: 'ล็อคส่วนลด',
                 allPlatform: 'แพลตฟอร์มทั้งหมด',
                 mainAccount: 'บัญชีหลัก',
                 bonusName: 'ชื่อโบนัส',
                 bonusType: 'ประเภทโบนัส',
                 platform: 'แพลตฟอร์ม',
                 bonusLockStatus: 'สถานะโบนัส',
                 deblockingSuccess: 'ปลดล็อกสำเร็จ',
            }
        },
        betlist: {
            allPlatform: 'แพลตฟอร์มทั้งหมด',
             bizNo: 'หมายเลขสลิปพนัน',
             platformCode: 'หมายเลขแพลตฟอร์ม',
             gameType: 'ประเภทเกม',
             betAmount: 'จำนวนเงินเดิมพัน (THB)',
             betAmount2: 'จำนวนเงินเดิมพัน:',
             betflow: 'การเดิมพันที่มีประสิทธิภาพ (THB)',
             betflow2: 'การเดิมพันที่มีประสิทธิภาพ:',
             resultAmount: 'กำไรของผู้เล่น (THB)',
             resultAmount2: 'กำไรของผู้เล่น:',
             betTime: 'เวลาเดิมพัน',
             createTime: 'เวลาการชำระบัญชี',
             selectTime: 'โปรดเลือกช่วงเวลา',
             nobetlist:'ไม่มีสถิติการเดิมพัน!',
             all:'เบ็ดเสร็จ:',
        },
        getBonus: {
            title: 'ศูนย์รับโบนัส',
             AccumulatedWithdrawalAmount: 'จำนวนเงินที่ถอนได้สะสม',
             AccumulatedBonus: 'โบนัสสะสม',
             canDraw: 'สามารถรับได้',
             ongoing: 'กำลังดำเนินการ',
             Finished: 'เสร็จสิ้น',
             refresh: 'รีเฟรชหนึ่งคลิก',
             noData: 'ไม่มีข้อมูลที่เกี่ยวข้องชั่วคราว',
             bonusName: 'ชื่อโปรโมชั่น',
             bonusMoney: 'จำนวนสัมปทาน',
             targetBetflow: 'ถอนกระแสเงินสดที่ต้องการ',
             pendingflow: 'กระแสที่รอดำเนินการ',
             DistributionTime: 'เวลาแจกจ่าย',
             handle: 'การดำเนินงาน',
             draw: 'รับ',
             total: 'จำนวน{num}รายการ',
             totalPage: 'รวม {num} หน้า',
             nowPage: 'ปัจจุบัน',
             previousPage: 'หน้าก่อนหน้า',
             nextPage: 'หน้าถัดไป',
             success: 'ขอแสดงความยินดีคุณได้รับความสำเร็จ! ',
             targetFlow: 'เป้าหมายน้ำไหล {targetAmount} เงินบาทไทย',
             finishedFlow: 'เสร็จสิ้นการไหล {validAmount} เงินบาทไทย',
        },
        billDetail: {
            toady: 'วันนี้',
            yesterday: 'เมื่อวาน',
             finalWeek: '7 วันล่าสุด',
             finalMonth: '30 วันล่าสุด',
             allType: 'ทั้งหมด',
             SystemTransfer: 'การถ่ายโอนระบบ',
             RepaidDeposit: 'เติมเงินมัดจำ',
             withdrawals: 'ถอนในไม่กี่วินาที',
             SwitchToGame: 'โอนไปยังเกม',
             GameOut: 'Game transfer out',
             discounts: 'โบนัสเสนอ',
             ManualDeposit: 'เงินฝากด้วยตนเอง',
             ManualRemoval: 'การลบด้วยตนเอง',
             transNo: 'หมายเลขสั่งซื้อ',
             orderName: 'ชื่อคำสั่งซื้อ',
             orderTime: 'เวลา',
             payType: 'ประเภทธุรกรรม',
             amount: 'จำนวน',
             status: 'สถานะ',
        },
        myDiscountin: {
            title: 'ข้อเสนอของฉัน',
             allType: 'ทุกประเภท',
             applying: 'การใช้',
             successCollection: 'รับสำเร็จ',
             finishFlow: 'เสร็จสิ้นการไหล',
             cancel: 'ปฏิเสธ',
             Clearance: 'การตรวจสอบที่ชัดเจน',
             Unclaimed: 'ไม่มีเหตุสมควร',
             noPrize: 'ไม่ได้เลือก',
             noOffer: 'ยังไม่มีส่วนลด',
             clickApply: 'คลิกเพื่อใช้',
            discountItem: {
                needLaveBetflow: 'ต้องการ {laveBetflow} THBคาสิโนที่ใช้น้ำเพื่อรับ',
                needLaveBetflow2: 'ต้องการ {laveBetflow} THBคาสิโนที่ใช้น้ำสามารถถอนได้',
                flowDone: 'น้ำไหลถึงแล้ว',
                loseEfficacy: 'ถูกต้อง',
            }
        },
        safein: {
            emailTitle: 'การตรวจสอบกล่องจดหมาย',
             emailSubTitle: 'ใช้เพื่อรีเซ็ตรหัสผ่านหรือการรับรองความถูกต้อง',
             nameTitle: 'การรับรองความถูกต้องชื่อจริง',
             nameSubTitle: 'ยืนยันข้อมูลตัวตน',
             phoneTitle: 'ผูกหมายเลขโทรศัพท์ของคุณ',
             phoneSubTitle: 'ถอนเงินออกไป',
             vipTitle: 'รหัสผ่านเข้าสู่ระบบ',
             vipSubTitle: 'ใช้เมื่อลงชื่อเข้าใช้บนเว็บไซต์และแอพมือถือ',
             codeTitle: 'ตั้งรหัสผ่านการถอนเงิน',
             revisecodeTitle: 'แก้ไขรหัสผ่านการถอนเงิน',
             codeSubTitle: 'ปกป้องบัญชีของคุณ! ',
             bankTitle: 'ผูกบัตรของธนาคาร {length} แล้ว',
             revise: 'ปรับเปลี่ยน',
             authen: 'ไปสู่การรับรอง',
             receive: 'รับส่วนลด',
             start: 'เปิดใช้งาน',
             customer: 'กรุณาติดต่อฝ่ายบริการลูกค้าสำหรับการปรับเปลี่ยน',
        },
        verifyEmail:{
            title: 'ผูกกล่องจดหมายของคุณ',
             subTitle1: 'โปรดป้อนที่อยู่อีเมลของคุณ',
             subTitle2: 'โปรดป้อนรหัสยืนยัน',
             sendcode: 'ส่งรหัสยืนยัน',
             suffix: 'ส่งอีกครั้งในไม่กี่วินาที',
             cancel: 'ยกเลิก',
             confrim: 'รับรอง',
             tips: 'หากคุณลืมข้อมูลเข้าสู่ระบบข้อมูลนี้จะถูกใช้เพื่อกู้คืนบัญชีของคุณ! ',
             emailHadSend: 'ส่งอีเมลแล้วโปรดตรวจสอบ',
             emailConfrim: 'การตรวจสอบกล่องจดหมาย',
        },
        verifyName:{
            title: 'การตรวจสอบชื่อจริงยืนยันข้อมูลตัวตน',
             subTitle1: 'กรุณาใส่ชื่อจริงของคุณ',
             subTitle2: 'โปรดป้อนหมายเลข ID ของคุณ',
             cancel: 'ยกเลิก',
             confrim: 'รับรอง',
             tips: 'เพื่อให้มั่นใจในความปลอดภัยและสิทธิ์ตามกฎหมายของบัญชีของคุณโปรดยืนยันว่าตัวตนของบัญชีเป็นของคุณ ',
             nameConfrim: 'การรับรองความถูกต้องชื่อจริง',
        },
        verifyPhone:{
            title: 'ผูกโทรศัพท์ของคุณ',
             subTitle1: 'โปรดป้อนหมายเลขโทรศัพท์มือถือของคุณ',
             subTitle2: 'โปรดป้อนรหัสยืนยัน',
             sendcode: 'ส่งรหัสยืนยัน',
             suffix: 'ส่งอีกครั้งในไม่กี่วินาที',
             cancel: 'ยกเลิก',
             confrim: 'รับรอง',
             tips: 'หากคุณลืมข้อมูลเข้าสู่ระบบข้อมูลนี้จะถูกใช้เพื่อกู้คืนบัญชีของคุณ! ',
             mileHadSend: 'SMS ถูกส่งไปแล้วโปรดตรวจสอบ',
             phoneConfrim: 'การพิสูจน์ตัวตนโทรศัพท์',
        },
        loginPassword:{
            title: 'เปลี่ยนรหัสผ่านการเข้าสู่ระบบ',
             subTitle1: 'โปรดป้อนรหัสผ่านการเข้าสู่ระบบเก่า',
             subTitle2: 'รหัสผ่านการเข้าสู่ระบบใหม่',
             subTitle3: 'ยืนยันรหัสผ่านใหม่',
             cancel: 'ยกเลิก',
             confrim: 'ปรับเปลี่ยน',
             tips: 'ข้อสังเกต: โปรดเก็บรหัสผ่านของคุณอย่างถูกต้องหากคุณลืมมันโปรดใช้ฟังก์ชั่นความปลอดภัยที่เป็นความลับในการเรียกคืนหรือติดต่อฝ่ายบริการลูกค้าออนไลน์เพื่อจัดการกับมัน',
             pleaseLogin: 'กรุณาเข้าสู่ระบบอีกครั้ง',
             oldpwdError: 'ข้อผิดพลาดของรูปแบบรหัสผ่านดั้งเดิม',
             pwdError: 'ข้อผิดพลาดการจัดรูปแบบรหัสผ่านใหม่',
             pswIsChange: 'เปลี่ยนรหัสผ่านการเข้าสู่ระบบ',
        },
        setPassword:{
            title: 'ตั้งรหัสผ่านการถอนเงิน',
             subTitle1: 'หมายเลขโทรศัพท์มือถือที่ผ่านการรับรอง',
             phoneFirst: 'โปรดตรวจสอบสิทธิ์โทรศัพท์ก่อน',
             subTitle2: 'โปรดป้อนรหัสยืนยัน',
             subTitle3: 'โปรดป้อนรหัสผ่านการชำระเงิน',
             subTitle4: 'ยืนยันรหัสผ่านใหม่',
             sendcode: 'ส่งรหัสยืนยัน',
             suffix: 'ส่งอีกครั้งในไม่กี่วินาที',
             cancel: 'ยกเลิก',
             confrim: 'การตั้งค่า',
             tips: 'ข้อสังเกต: โปรดเก็บรหัสผ่านของคุณอย่างถูกต้องหากคุณลืมโปรดติดต่อฝ่ายบริการลูกค้าออนไลน์เพื่อจัดการกับมัน',
             mileHadSend: 'SMS ถูกส่งไปแล้วโปรดตรวจสอบ',
        },
        changePassword:{
            title: 'แก้ไขรหัสผ่านการถอนเงิน',
             subTitle1: 'หมายเลขโทรศัพท์มือถือที่ผ่านการรับรอง',
             phoneFirst: 'โปรดป้อนรหัสผ่านการชำระเงิน',
             subTitle2: 'โปรดป้อนรหัสยืนยัน',
             subTitle3: 'โปรดป้อนรหัสผ่านการชำระเงินเก่า',
             subTitle4: 'โปรดป้อนรหัสผ่านการชำระเงินใหม่',
             subTitle5: 'ยืนยันรหัสผ่านใหม่',
             sendcode: 'ส่งรหัสยืนยัน',
             suffix: 'ส่งอีกครั้งในไม่กี่วินาที',
             cancel: 'ยกเลิก',
             confrim: 'ปรับเปลี่ยน',
             tips: 'ข้อสังเกต: โปรดเก็บรหัสผ่านของคุณอย่างถูกต้องหากคุณลืมโปรดติดต่อฝ่ายบริการลูกค้าออนไลน์เพื่อจัดการกับมัน',
             mileHadSend: 'SMS ถูกส่งไปแล้วโปรดตรวจสอบ',
        },
        email:{
            title: 'จดหมายสถานี',
             mineMsg: 'ข้อความของฉัน',
             newMsg: 'ข่าวล่าสุด',
             hasRead: 'อ่านข้อความ',
             noMsg: 'ยังไม่มีข่าว',
             del: 'ลบ',
             sendMsg: 'ส่งข้อความใหม่',
             msgType: 'ประเภทข้อความ:',
             please: 'โปรดเลือก',
             PleaseCheck: 'โปรดเลือกประเภทคำถาม',
             mine: 'ธีม:',
             minePlease: 'โปรดป้อนหัวเรื่อง',
             content:' เนื้อหา: ',
             contentPlaese: 'โปรดป้อนเนื้อหา',
             send:'ส่ง',
             question1: 'ปัญหาการฝากและถอนเงิน',
             question2: 'กิจกรรมส่งเสริมการขาย',
             question3: 'ปัญหาของเกม',
             question4: 'คำถามอื่น ๆ ',
             question5: 'คำแนะนำ',
             question6: 'ร้องเรียน',
             checkInfo: 'โปรดเลือกเพื่อลบข้อมูล',
             delSuccess: 'ลบสำเร็จ',
             submitSuccess: 'ส่งสำเร็จ',
             finishContent: 'กรุณากรอกเนื้อหาให้ครบถ้วน',
        }

    },
    game:{
        playNow: 'เล่นเลย',
         ComingSoon: 'โปรดติดตามความคืบหน้า',
         realMoney: 'เงินจริง',
         try: 'ลองเล่น',
         noData: 'ยังไม่มีเกมที่เกี่ยวข้อง',
    },
    slot:{
        gameSearch: 'ค้นหาเกม',
        reset: 'รีเซ็ตตัวเลือก',
         mineCollect: 'รายการโปรดของฉัน',
         mineCollect2: 'ไม่มีคอลเลกชัน！',
         gameLobby: 'Game Lobby:',
         gameTypes: 'ประเภทเกม',
         hotGame: 'เกมน่าสนใจ',
         newGame: 'เกมล่าสุด',
         recommend: 'เกมแนะนำ',
         all: 'ทั้งหมด',
         PrizePoolGame: 'เกมพูลรางวัล',
         classicGame: 'เกมคลาสสิค',
         xxl: 'Xiao Xiao Le',
         electricHorn: 'ช่องเสียบไฟฟ้า',
         line: 'เส้น',
         pleaseEnter: 'โปรดป้อนเนื้อหาการค้นหา',
         add: 'เพิ่มคอลเล็กชัน',
         addSuucess: 'เพิ่มรายการโปรดเรียบร้อยแล้ว',
         cancelSuccess: 'การรวบรวมที่ประสบความสำเร็จถูกยกเลิก',
         hadCollect: 'ชื่นชอบ',
         late: 'โปรดลองอีกครั้งในภายหลัง',
         noLogin: 'คุณสามารถรวบรวมเกมได้หลังจากลงชื่อเข้าใช้! ',
         hotGameRank:'เกมการพนันยอดนิยม',
         loading: 'กำลังโหลดอย่างสิ้นหวัง',
         gogame: 'เข้าสู่เกม',
         describe: 'กรุณาเข้าสู่ระบบเพื่อดู!',
         title1: 'ดูล่าสุด',
         title2: 'เดาว่าคุณชอบ'
    },
    
    hotRanking:{
        TOP:'เกมเดิมพัน 5 อันดับแรก',
        time:'เวลาสถิติ:',
        hot: 'ยอดนิยมที่สุด',
        type: 'สล็อตแมชชีนคลาสสิค / เงินรางวัล',
        num: 'ขนาดรหัส:',
        gogema: 'เข้าร่วมทันที'
    },
    footer:{
        link: 'Liên kết nhanh',
        link2: 'Về chúng tôi',
        desc: 'Chào mừng bạn đến với VND188, trang web cá cược giải trí trực tuyến hàng đầu châu Á, mang đến cho bạn trải nghiệm cá cược trực tuyến khác nhau, bao gồm cá cược thể thao, sòng bạc trực tuyến, trò chơi sòng bạc trực tiếp, poker trực tuyến, slot game và nhiều trò chơi cá cược đẳng cấp thế giới.',
        copyright: 'Copyright © {year} | VND188 | Copyright',
        title: 'ข้อมูลที่เกี่ยวข้อง',
        title2: 'ความสัมพันธ์ความร่วมมือ',
        title3: 'การบริการลูกค้า',
        Aboutzaza:'บนzaza',
        AboutzazaContent:'ในบรรดาไซต์เกมจำนวนมากในตลาดผู้เล่นได้เลือกzazaนอกเหนือจากผลิตภัณฑ์ที่หลากหลายเนื่องจากเรามีชื่อเสียงที่ดีในอุตสาหกรรมและบริการที่มีคุณภาพสูงความตั้งใจของเราสามารถเห็นได้ทุกที่โดยไม่มีมัลแวร์ และได้รับการรับรองระหว่างประเทศ GEOSTRUST เพื่อให้แน่ใจถึงความยุติธรรมและความเป็นธรรมของเว็บไซต์ข้อมูลสมาชิกทั้งหมดจะถูกเข้ารหัสเพื่อปกป้องความเป็นส่วนตัวของผู้เล่น ด้วยจิตวิญญาณของการให้บริการสมาชิกโดยไม่ปิดเราจัดการเรื่องที่เกี่ยวข้องกับการฝากและถอนเงินสมาชิกตลอด 24 ชั่วโมงทำให้ทีมบริการลูกค้าของเรามีความภาคภูมิใจและเป็นมืออาชีพแก้ปัญหาโรคที่รักษาไม่หายทุกชนิดของผู้เล่นบนเว็บไซต์และเกมและทำให้ผู้เล่นแต่ละคนรู้สึกเหมือนอยู่บ้าน! สิ่งที่คุณต้องการคือสิ่งที่เราดำเนินการและเราเป็นทางเลือกที่ดีที่สุดของคุณ',
        commonProblem:'ปัญหาที่พบบ่อย',
        commonProblemContent:'ด้วยคำถามทั่วไปคุณสามารถตอบคำถามได้ทันทีเช่นวิธีตั้งค่าบัญชี zaza เติมเงินและถอนเงินและวิธีเล่นเกม',
        contactUs:'ติดต่อเรา',
        contactUsContent:'ผู้เล่นสามารถติดต่อเราผ่านทางบริการลูกค้าออนไลน์และอีเมล 7x24 ชั่วโมงที่ Sun City VIP Lounge การรักษาความลับของข้อมูลของผู้เล่นแต่ละคนนั้นสำคัญที่สุดสำหรับเราและเราสัญญาว่าจะดำเนินการต่อไปตามระบบการรักษาความลับและความเป็นส่วนตัวที่เข้มงวด',
        LiveCasino:'เล่นเกมระดับปานกลาง',
        LiveCasinoContent:'เราส่งเสริมการพนันอย่างควบคุมและปฏิเสธผู้เล่นที่ยังไม่บรรลุนิติภาวะโดยใช้ซอฟต์แวร์ของเราเพื่อความบันเทิงออนไลน์ ในเวลาเดียวกันเรายังใช้ผู้เชี่ยวชาญและวิธีการที่มีประสิทธิภาพเพื่อป้องกันปัญหาการพนัน。',
        Bowling:'คาสิโนสด',
        BowlingContent:'ด้วยเทคโนโลยีที่สูงที่สุดและดีลเลอร์แสดงสดที่สวยงามฮอตห้องวีไอพีซิตี้นำเสนอเกมคาสิโนสดยอดนิยมมากมายรวมถึงบาคาร่าบันเทิงสดกระบองซิคโบเกมมังกรเสือและรูเล็ต ผ่านวิดีโอสดผู้เล่นสามารถสัมผัสประสบการณ์การเดิมพันที่ยอดเยี่ยมได้ทันที',
        Slot:'ลูกเปตอง',
        SlotContent:'หน้าการเดิมพันกีฬาใหม่มีมากกว่า 10,000 เกมที่เลือกในแต่ละเดือนซึ่งสูงที่สุดในทั้งบรรทัด แน่นอนว่าในพรีเมียร์ลีก, เซเรียอา, ลาลีกา, บุนเดสลีกา, แชมเปี้ยนส์ลีกและการแข่งขันระดับนานาชาติอื่น ๆ นั้นเป็นสิ่งที่ขาดไม่ได้',
        MatchResult:'สล็อตและวิดีโอเกม',
        MatchResultContent:'ด้วยสล็อตแมชชีนหลากหลายรูปแบบและวิดีโอเกมสร้างจุดร้อนที่น่าตื่นเต้นใหม่ที่น่าตื่นเต้นและเป็นที่นิยมอย่างมาก',
        LiveCasinoRules:'ผลการแข่งขัน',
        LiveCasinoRulesContent:'ผู้เล่นสามารถทราบผลทันทีแบบเรียลไทม์และสิ้นสุดของการแข่งขันกีฬาทั้งหมดใน zaza',
        PokerGameRules:'กฎของคาสิโนสด',
        PokerGameRulesContent:'การเดิมพันคาสิโนสดทั้งหมดบน zaza ขึ้นอยู่กับการเดิมพันคาสิโนสดของเราและกฎระเบียบและข้อบังคับของสถานที่ที่ออกใบอนุญาต',
        BettingRecord:'กฎของเกมโป๊กเกอร์',
        BettingRecordContent:'การเดิมพันเกมโป๊กเกอร์ทั้งหมดใน zaza จะเป็นไปตามข้อบังคับและกฎของเกมโป๊กเกอร์และตำแหน่งที่ออกใบอนุญาต。',
        ModerateGambling:'บันทึกการเดิมพัน',
        ModerateGamblingContent:'ผ่านระบบเกมหรือศูนย์ผู้ใช้ที่ได้รับจาก zaza ผู้เล่นสามารถตรวจสอบการเดิมพันและบันทึกการทำธุรกรรมได้ทุกที่ทุกเวลา',

    },
    form: {
        //
        checkMoney1: 'โปรดป้อนจำนวน',
        checkMoney2: 'รูปแบบจำนวนเงินไม่ถูกต้อง',
        checkMoney3: 'จำนวนเงินต้องไม่เป็น 0',
        checkWithdraw: 'โปรดป้อนรหัสผ่าน',
        checkRealname: 'กรุณาใส่ชื่อจริงของคุณ',
        // / ** ยืนยันบัตรธนาคาร ** /
        checkBankNumber1: 'กรุณาใส่หมายเลขบัตรเครดิตธนาคาร',
        checkBankNumber2: 'รูปแบบหมายเลขบัตรธนาคารไม่ถูกต้อง',
        // / ** ยืนยันสาขา ** /
        checkBranch: 'โปรดป้อนสาขาที่เปิดบัญชี',
        /** ตรวจสอบอีเมล์ */
        checkEmail1: 'โปรดป้อนอีเมลของคุณ',
        checkEmail2: 'ข้อผิดพลาดการจัดรูปแบบกล่องจดหมาย',
        // / ** ยืนยัน ID ** /
        checkCard1: 'กรุณาใส่หมายเลขประจำตัว',
        checkCard2: 'รูปแบบ ID ผิด',
        // / ** ตรวจสอบหมายเลขโทรศัพท์มือถือ ** /
        checkPhone1: 'โปรดป้อนหมายเลขโทรศัพท์มือถือของคุณ',
        checkPhone2: 'โปรดป้อนหมายเลขโทรศัพท์มือถือที่ถูกต้อง',
        /** ยืนยันรหัสผ่าน */
        checkPassword: 'กรุณาใส่รหัสผ่านของคุณ',
        // / ** ยืนยันรหัสผ่าน * /
        checkConfirm1: 'กรุณาใส่รหัสผ่านอีกครั้ง',
        checkConfirm2: 'การป้อนรหัสผ่านสองครั้งไม่สอดคล้องกัน',
        // / ** ยืนยันรหัสผ่านเดิมเพื่อยืนยันรหัสผ่าน ** /
        checkConfirms: 'รหัสผ่านใหม่เหมือนกับรหัสผ่านเดิม',
        // / ** ยืนยันรหัสยืนยัน ** /
        checkVerifiCode1: 'รหัสยืนยันต้องไม่ว่างเปล่า',
        checkVerifiCode2: 'ข้อผิดพลาดการจัดรูปแบบรหัสตรวจสอบ',
        /** ตรวจสอบบัญชี **/
        checkUsername1: 'โปรดป้อนหมายเลขบัญชีของคุณ',
        checkUsername2: 'บัญชีประกอบด้วยตัวเลข 6-12 หลัก, ต้องเริ่มต้นด้วยตัวอักษร',
        // / ** ยืนยันหมายเลขต่างประเทศ ** /
        checkPhoneNumber1: 'โปรดป้อนหมายเลขโทรศัพท์ที่ถูกต้อง',
        checkPhoneNumber2: 'โปรดป้อนหมายเลขโทรศัพท์',
        // / ** ยืนยันรหัสผ่านการลงทะเบียน ** /
        checkRegisterPassword1: 'โปรดป้อนรหัสผ่าน',
        checkRegisterPassword2: 'รหัสผ่านประกอบด้วยตัวเลข 6-12 หลักและต้องประกอบด้วยตัวอักษรและตัวเลข',
        // / ** ยืนยันชื่อจริง ** /
        checkrealName1: 'ชื่อจริงต้องไม่ว่างเปล่า',
        checkrealName2: 'ชื่อจริงต้องไม่น้อยกว่า 2 ตัว',
        // / ** ตรวจสอบ qq ** /
        checkQQ1: 'qq ต้องไม่ว่างเปล่า',
        checkQQ2: 'qq ต้องไม่น้อยกว่า 6 ตัว',
        // / ** ตรวจสอบ WeChat ** /
        checkwechat1: 'WeChat ต้องไม่ว่างเปล่า',
        checkwechat2: 'WeChat ต้องไม่น้อยกว่า 10 ตัว',
        // /** ตรวจสอบอีเมล์ **/
        checkemail1: 'กล่องจดหมายต้องไม่ว่างเปล่า',
        checkemail2: 'WeChat ต้องไม่น้อยกว่า 13 ตัวอักษรหรือมากกว่า 20 ตัว',
        checkemail3: 'โปรดป้อนรูปแบบกล่องจดหมายที่ถูกต้อง',
        // / ** ยืนยันรหัสผ่านการถอนเงิน  **/
        checkwithdrawPassword1: 'รหัสผ่านการถอนไม่สามารถว่างเปล่า',
        checkwithdrawPassword2: 'รหัสผ่านการถอนไม่สามารถน้อยกว่า 6 หลัก',

    },
    common: {
        loading: 'กำลังโหลดอย่างสิ้นหวัง',
        loading2: 'อัปเดตรายการ',
        search: 'ค้นหา',
        tips: 'เคล็ดลับที่อบอุ่น',
        congratulations: 'ขอแสดงความยินดี! ',
        success: 'ความสำเร็จ',
         confirmButtonText: 'ตกลง',
         confirmButtonText2: 'เข้าใจแล้ว',
         cancelButtonText: 'ยกเลิก',
         money: 'THB',
         needLogin: 'คุณสามารถเล่นได้หลังจากล็อกอินเท่านั้น',
         tryTitle: 'ไม่มีรางวัลสำหรับการทดลองเล่นคุณต้องการดำเนินการต่อหรือไม่',
         tryTitle2: 'เกมไม่สามารถเล่นได้ให้ไปที่เข้าสู่ระบบ?',
         loginOut: 'ออกจากระบบ',
         close: 'ปิด',
    },
    timer: {
        finalWeek: 'สัปดาห์ที่แล้ว',
         finalMonth: 'เดือนที่แล้ว',
         finalThreeMonth: 'สามเดือนล่าสุด',

    },
    state: {
        discountsTypes: {
            all: 'ทุกประเภท',
             rebateBonus: 'โบนัสคืนเงิน',
             depositDiscount: 'ข้อเสนอการฝาก',
             RescueFund: 'กองทุนกู้ภัย',
             UpgradeAward: 'รางวัลการอัพเกรดระดับ VIP',
             WinningAwards: 'รางวัลความสำเร็จระดับ VIP',
             OtherPreferences : 'ข้อเสนออื่น ๆ ',
             RegistrationPreferences: 'ข้อเสนอการลงทะเบียน',
        },
        sports_gameTypes: {
            allGame: 'เกมทั้งหมด',
            slots: 'วิดีโอเกม',
            live: 'วิดีโอสด',
            sport: 'การเดิมพันกีฬา',
            lottery: 'เกมลอตเตอรี',
            fish: 'ราชาตกปลา',
            chess: 'เกมหมากรุก',
            other : 'อื่น ๆ',
        }
    },
    filter: {
        changeName: {
            allType: 'ทุกประเภท',
            applying: 'การใช้ ',
             successCollection: 'รับสำเร็จ',
             finishFlow: 'เสร็จสิ้นการไหล',
             cancel: 'ปฏิเสธ',
             Clearance: 'การตรวจสอบที่ชัดเจน',
             Unclaimed: 'ไม่มีเหตุสมควร',
             noPrize: 'ไม่ได้เลือก',
        },
        bonusTypes: {
            Predividend: 'Predividend',
             Postdividend: 'Post bonus',
             Deductdividends: 'ลบเงินปันผล',
        },
        bonusName: {
            rebateBonus: 'โบนัสคืนเงิน',
             depositDiscount: 'ข้อเสนอการฝาก',
             Invitation: 'รางวัลคำเชิญ',
             signin: "ลงชื่อเข้าใช้รางวัล",
             ContinuousDeposit: 'ข้อเสนอการฝากอย่างต่อเนื่อง',
             register: 'ข้อเสนอการลงทะเบียน',
             RescueFund: 'กองทุนกู้ภัย',
             UpgradeAward: 'รางวัลการอัพเกรดระดับ VIP',
             WinningAwards: 'รางวัลความสำเร็จระดับ VIP',
             OtherPreferences : 'ข้อเสนออื่น ๆ ',
        },
        bonusLockPlatform:{
            mineAccount: 'บัญชีหลัก'
        },
        bonusLockStatus:{
            status1: 'ล็อค',
             status2: 'ปลดล็อก',
             status4: 'ยกเลิก',
        },
        depositLockStatus:{
            status1: 'ล็อค',
             status2: 'ปลดล็อก',
             status3: 'ล็อค',
        },
        gameName:{
            name1: 'สล็อตแมชชีน',
             name2: 'คนจริง',
             NAME3: 'กีฬา',
             NAME4: 'หวย',
             name5: 'Fishing King',
             name6: 'หมากรุก',
             name7: '3D Hall',
        },
        changeTitle:{
            NAME0: 'การยื่น',
             name1: 'การถ่ายโอนระบบ',
             name2: 'เติมเงินมัดจำ',
             name3: 'ถอนออกในไม่กี่วินาที',
             name4: 'ไปที่เกม',
             name5: 'เกมโอนออก',
             name8: 'โบนัสเสนอ',
             name9: 'เงินฝากด้วยตนเอง',
             name10: 'นำออกด้วยตนเอง',
        },
        withdrawalStatus: {
            withdrawalStatus0: 'การยื่น',
            withdrawalStatus1: 'ถอน',
            withdrawalStatus2: 'ความสำเร็จ',
            withdrawalStatus3: 'ปฏิเสธ',
            withdrawalStatus4: 'ถอน',
            withdrawalStatus5: 'ถอน',
        }
    },
    catchFish:{
        in:'ใน',
        income: 'รายได้สองเท่า',
         Deepsealive: 'อาศัยอยู่ใต้ทะเลลึก',
         Deepsealive2: 'อัปเดตสด',
         time: 'นาทีก่อน',
         time2: 'การจับภาพระดับกลาง',
         time3: 'หนึ่ง',
         fishKing: 'ราชาตกปลาเมื่อสัปดาห์ที่แล้ว',
         fishKing2: 'อัพเดททุกวันอังคาร',
    },
    invitation:{
        title: 'เชิญเพื่อน',
        title2: 'ลิงค์แนะนำพีซี:',
        title3: 'เพื่อนของฉัน',
        copy: 'ลิงค์คัดลอก',
        registereduser: 'ผู้ใช้ที่ลงทะเบียน',
        time: 'เวลา',
        InviteeStatus: 'สถานะบุคคลที่ได้รับเชิญ',
        BonusStatus: 'สถานะโบนัส',
        Received: 'ได้รับ',
        receive: 'รับ',
        expired: 'หมดอายุ',
        ActivityRules: 'กฎกิจกรรม:',
        ActivityRules2: 'ผู้ได้รับเชิญต้องได้รับโบนัสก่อนและความสามารถที่ได้รับเชิญจะได้รับโบนัส ',
        CopySuccessful: 'คัดลอกสำเร็จ',
        SuccessfullyReceived: 'ได้รับเรียบร้อยแล้ว',
    },
    jackpot:{
        Listofwinners: 'รายการที่ชนะ',
        accountNumber: 'ผู้ใช้งาน',
        game: 'เกม',
        bonus: 'โบนัส'
    },
    marquree:{
        Notice: 'ประกาศ',
        Close: 'ปิด'
    },
    ...thLocale
}

export default th_TH


// WEBPACK FOOTER //
// ./src/pages/build902/i18n/langs/th_TH.js